export default __webpack_public_path__ + "static/media/img-store-machines.21b7214a.png";